import React from 'react';
import * as PropTypes from 'prop-types';

import { ChatClientContextProvider } from '../state/chat-client.state';
import VoipPanel from '../voip-panel';

const ChatProvider = (props) => {
    const { children, chatFlags, studyNameGetter, dashboard } = props;

    return (
        <ChatClientContextProvider dashboard={dashboard} chatFlags={chatFlags} studyNameGetter={studyNameGetter}>
            {children}
            <VoipPanel />
        </ChatClientContextProvider>
    );
};

ChatProvider.propTypes = {
    children: PropTypes.node.isRequired,
    chatFlags: PropTypes.oneOfType([PropTypes.object]).isRequired,
    studyNameGetter: PropTypes.func.isRequired,
    dashboard: PropTypes.oneOf(['rdash', 'pdash']).isRequired,
};

export default ChatProvider;
